import { render, staticRenderFns } from "./count2.vue?vue&type=template&id=6c524efe&scoped=true&"
import script from "./count2.vue?vue&type=script&lang=js&"
export * from "./count2.vue?vue&type=script&lang=js&"
import style0 from "./count2.vue?vue&type=style&index=0&id=6c524efe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c524efe",
  null
  
)

export default component.exports